import React from 'react';
import { Button } from '@global-ecom/nitro-uds/elements';

import { Button as LegacyButton } from 'ui/elements/Button';
import Modal from 'ui/components/Modal';
import { useTranslate } from 'hooks/useTranslations';

import CloseButton from './CloseButton';
export const ConfirmModal: React.FC<{
  onClickOutside: () => void;
  onConfirm: () => void;
  dataTestId?: string;
  loading?: boolean;
  confirmText?: string;
  cancelText?: string;
  reverseButtonOrder?: boolean;
}> = ({
  onClickOutside,
  children,
  onConfirm,
  dataTestId,
  loading,
  confirmText,
  cancelText,
  reverseButtonOrder,
}) => {
  const t = useTranslate();

  const confirmButton = () => (
    <LegacyButton
      id="confirm-button"
      dataTestId="confirm-button"
      loading={loading}
      label={confirmText ?? t('confirmButtonModal')}
      className="flex-grow h-[2.5rem]"
      onClick={onConfirm}
    >
      {confirmText ?? t('confirmButtonModal')}
    </LegacyButton>
  );

  const cancelButton = () => (
    <Button
      id="cancel-button"
      dataTestId="cancel-button"
      label={cancelText ?? t('cancelButtonModal')}
      variant={reverseButtonOrder ? 'secondary' : 'primary'}
      className="flex-grow"
      onClick={onClickOutside}
    />
  );
  return (
    <Modal
      onClickOutside={onClickOutside}
      variant="dark"
      className="max-w-lg p-6"
      dataTestId={dataTestId}
    >
      <CloseButton
        className="absolute top-5 right-5 !mt-0"
        onClick={onClickOutside}
      />
      <div className="space-y-6">
        {children}
        <div className="flex space-x-4 w-full">
          {reverseButtonOrder ? (
            <>
              {cancelButton()}
              {confirmButton()}
            </>
          ) : (
            <>
              {confirmButton()}
              {cancelButton()}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
